import { initializeApp } from 'firebase/app';
import { getFirestore, collection, addDoc, getDocs, updateDoc, doc, query, where } from 'firebase/firestore';
import * as firebaseConfig from './config.json';
// TODO: Replace the following with your app's Firebase project configuration

const firebaseApp = initializeApp(firebaseConfig);
const db = getFirestore(firebaseApp);

console.log(db)

export const savePrompt = async (prompt, icon) => {
    const prompts = await getAllPrompts();
    if(prompts.find(e => e.prompt == prompt)) return alert('Prompt already exists')
    if(prompts.find(e => e.icon == icon)) return alert('Icon already in use')

    const promptCol = collection(db, 'prompts');
    const result = await addDoc(promptCol, {prompt: prompt, icon:icon, inUse: false})
    if(result) {
      alert('Success!')
      return true;
    }
    
}

export const getAllPrompts = async () => {
  const promptCol = collection(db, 'prompts');
  const snapshot = await getDocs(promptCol);
  const promptList = snapshot.docs.map(doc => doc.data());
  return promptList;
}

export const getInitialFive = async () => {
  let data = [];
  console.log('Loading...')
  const q = query(collection(db, 'prompts'), where('inUse', '==',false));
  const querySnapshot = await getDocs(q);
  let shuffled = shuffle(querySnapshot.docs);
  let counter = 0;
  shuffled.forEach((doc) => {
    if(counter < 6){
      data.push(doc.data());
      counter++;
    }
    //updateInUsePrompt(doc.id)
  })
  console.log(data);
  return data;
}

export const updateInUsePrompt = async (docID) => {
  await updateDoc(doc(db, 'prompts', docID), {
    inUse: true
  });
}

export function shuffle(array) {
  let currentIndex = array.length,  randomIndex;

  // While there remain elements to shuffle.
  while (currentIndex != 0) {

    // Pick a remaining element.
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex--;

    // And swap it with the current element.
    [array[currentIndex], array[randomIndex]] = [
      array[randomIndex], array[currentIndex]];
  }

  return array;
}